import ContactAPI from 'dashboard/api/contacts';
import { brazilianDateToIso } from 'shared/helpers/talkviaInputMasks';

export const isValidCpf = cpf => {
  if (!/^\d{11}$/.test(cpf) || /^(\d)\1{10}$/.test(cpf)) return false;
  return [9, 10].every(length => {
    const sum = [...cpf.slice(0, length)].reduce(
      (total, digit, index) => total + Number(digit) * (length + 1 - index),
      0
    );
    return ((sum * 10) % 11) % 10 === Number(cpf[length]);
  });
};

export const isValidMobile = phone => /^[1-9]\d9\d{8}$/.test(phone);

export const findContact = async (query, matches) => {
  let page = 1;
  let hasMore = true;
  while (hasMore) {
    // Pagination depends on the has_more flag returned by the previous request.
    // eslint-disable-next-line no-await-in-loop
    const { data } = await ContactAPI.search(query, page);
    const contacts = data?.payload || [];
    const contact = contacts.find(matches);
    if (contact) return contact;
    hasMore = contacts.length > 0 && data?.meta?.has_more === true;
    page += 1;
  }
  return null;
};

export const registerBankContact = async (cpf, customer, getCpf) => {
  if (!isValidCpf(cpf) || !isValidMobile(customer.phone)) {
    throw new Error('Informe um CPF válido e um celular com DDD.');
  }
  const existingCpf = await findContact(cpf, item => getCpf(item) === cpf);
  if (existingCpf) return existingCpf;

  const phoneNumber = `+55${customer.phone}`;
  const existingPhone = await findContact(
    phoneNumber,
    item => item.phone_number === phoneNumber
  );
  if (existingPhone) {
    if (getCpf(existingPhone) && getCpf(existingPhone) !== cpf) {
      throw new Error(
        'Este celular já está vinculado a outro CPF. Revise o número informado.'
      );
    }
    await ContactAPI.update(existingPhone.id, {
      custom_attributes: { ...existingPhone.custom_attributes, cpf },
    });
    return existingPhone;
  }

  const { data } = await ContactAPI.create({
    name: customer.name.trim() || phoneNumber,
    phone_number: phoneNumber,
    ...(customer.email ? { email: customer.email } : {}),
    custom_attributes: {
      cpf,
      ...(customer.mother_name ? { nome_mae: customer.mother_name } : {}),
      ...(customer.birth_date
        ? { data_nascimento: brazilianDateToIso(customer.birth_date) }
        : {}),
    },
  });
  const contact = data?.payload?.contact;
  if (!contact?.id)
    throw new Error('Não foi possível confirmar o cadastro do contato.');
  return contact;
};
